import {
  isAudioFile,
  isDocFile,
  isImageFile,
  isNoSystemFolder,
  isPdfFile,
  isPptFile,
  isSystemFolder,
  isVideoFile,
  isXlsFile,
} from '../../utils/file'

import { FILE_ICON, FILE_ICON_COLOR, FileIconType } from './FileIcon.constants'

export function getFileIconType(file) {
  switch (true) {
    case isPdfFile(file):
      return FileIconType.Pdf
    case isDocFile(file):
      return FileIconType.Doc
    case isXlsFile(file):
      return FileIconType.Xls
    case isPptFile(file):
      return FileIconType.Ppt
    case isImageFile(file):
      return FileIconType.Image
    case isVideoFile(file):
      return FileIconType.Video
    case isAudioFile(file):
      return FileIconType.Audio
    case isSystemFolder(file):
      return FileIconType.FolderSystem
    case isNoSystemFolder(file):
      return FileIconType.FolderNoSystem
    default:
      return FileIconType.Default
  }
}

export function getFileIconColor(type) {
  return FILE_ICON_COLOR[type]
}

export function getFileIcon(type) {
  return FILE_ICON[type]
}
